import { UNIFI_CHAIN_ID } from "./network";

// Contract addresses on Unifi Testnet.
// Defaults are the public testnet deployments; override via REACT_APP_* env.
export const CONTRACTS = {
  USDC:
    process.env.REACT_APP_USDC_ADDRESS ??
    "0xa1706a87F06d4F0F379A9123e41672924B654550",
  PAYMENT_FACILITATOR:
    process.env.REACT_APP_PAYMENT_FACILITATOR_ADDRESS ??
    "0xA88288C4314B390F7E0DE9fb04DAE4c0c6bb1459",
} as const;

// x402 Payment Configuration.
export const X402_CONFIG = {
  MERCHANT_ADDRESS:
    process.env.REACT_APP_MERCHANT_ADDRESS ??
    "0x3C44CdDdB6a900fa2b585dd299e03d12FA4293BC",
  PAYMENT_AMOUNT: process.env.REACT_APP_PAYMENT_AMOUNT ?? "100000", // 0.1 USDC (6 decimals)
  SERVICE_NAME: process.env.REACT_APP_SERVICE_NAME ?? "Paid Content Access",
  TASK_DESCRIPTION:
    process.env.REACT_APP_TASK_DESCRIPTION ?? "x402-api-payment",
} as const;

// EIP712 Domain for PaymentFacilitator
export const EIP712_DOMAIN = {
  name: "PaymentFacilitator",
  version: "1",
  chainId: UNIFI_CHAIN_ID,
  verifyingContract: CONTRACTS.PAYMENT_FACILITATOR,
} as const;
